<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style >
.content{
  padding: 15px;
}
.margin-top{
  margin-top:15px;
}
.margin-bottom{
  margin-bottom:15px;
}
.el-pagination{
  text-align: right;
  margin-top: 20px;
}
</style>

